import React from 'react';
import {
    BooleanField,
    BooleanInput,
    Create,
    Datagrid,
    Edit,
    EditButton,
    List,
    maxLength,
    SelectInput,
    SimpleForm,
    TextField,
    NumberInput,
    TextInput,
    required,
    choices, regex,
} from 'react-admin';
import {Grid, Typography} from "@mui/material";

// Validation configuration
const validateText = [maxLength(100, "Bitte maximal 100 Zeichen eingeben"), required("Dieses Feld ist ein Pflichtfeld")]
const validateNumber = [maxLength(30, "Bitte maximal 30 Zeichen eingeben"), required("Dieses Feld ist ein Pflichtfeld")]
const validateAssetUrl = [regex(/^https:\/\/([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d{1,5})?(\/.*)?$/, "Falsches Linkformat. Nur interne Links mit solche Vorlagen werden akzeptiert. (Korrekt: https://abcd.abcd.abcd/abcd/abcd/)")]
const validateLinkUrl = [regex(/^https:\/\/([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d{1,5})?(\/.*)?$/, "Falsches Linkformat. Nur interne Links mit solche Vorlagen werden akzeptiert. (Korrekt: https://abcd.abcd.abcd/abcd/abcd/)")]
const validateLinkTarget = [choices(['_blank', '_self', '_parent', '_top']), required("Dieses Feld ist ein Pflichtfeld")]
const validateButtonText = [maxLength(50, "Bitte maximal 50 Zeichen eingeben")]
const validateButtonColor = [choices(['primary', 'secondary']), required("Dieses Feld ist ein Pflichtfeld")]

export const ECBList = (props) => (
    <List {...props}>
        <Datagrid>
            <BooleanField label="Sichtbar?" source="isVisible"/>
            <TextField label="Link-URL" source="link.linkUrl"/>
            <TextField label="Button-Text" source="link.buttonText"/>
            <BooleanField label="Button-Sichtbar" source="link.buttonVisibility"/>
            <TextField label="Asset-URL" source="assetUrl"/>
            <TextField label="Alternativtext" source="altText"/>
            <EditButton/>
        </Datagrid>
    </List>
);

const ECBForm = props => (
    <SimpleForm>
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Typography variant="h4">
                    {props.title}
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <Typography variant="h6" gutterBottom>
                    Grundeinstellungen
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <BooleanInput label="ECB ist sichtbar?" source="isVisible" />
            </Grid>
            <Grid item xs={12} md={4}>
                <TextInput fullWidth label="Asset-URL" source="assetUrl" validate={validateAssetUrl}/>
            </Grid>
            <Grid item xs={12} md={4}>
                <TextInput fullWidth label="Alternativtext" source="altText" validate={validateText}/>
            </Grid>
            <Grid item xs={12} md={4}>
                <NumberInput fullWidth label="Position in der Liste (Nummerierung beginnt bei 0)" source="order" validate={validateNumber}/>
            </Grid>
        </Grid>

        <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
                <Typography variant="h6" gutterBottom style={{marginTop: 20}}>
                    Button-Konfiguration
                </Typography>

                <TextInput fullWidth label="Button-Text" source="link.buttonText" validate={validateButtonText}/>

                <SelectInput
                    fullWidth
                    label="Button-Farbe"
                    source="link.buttonColor"
                    choices={[
                        { id: 'primary', name: 'Primärfarbe' },
                        { id: 'secondary', name: 'Sekundärfarbe' }
                    ]} validate={validateButtonColor}/>

                <BooleanInput label="Kontur-Button?" source="link.outline" />

                <BooleanInput label="Button sichtbar?" source="link.buttonVisibility" />
            </Grid>
            <Grid item xs={12} md={6}>
                <Typography variant="h6" gutterBottom style={{marginTop: 20}}>
                    Link-Konfiguration
                </Typography>

                <TextInput fullWidth label="Link-URL (Asset oder Button)" source="link.linkUrl" validate={validateLinkUrl}/>

                <SelectInput
                    fullWidth
                    label="Link-URL"
                    source="link.linkTarget"
                    choices={[
                        { id: '_blank', name: 'Neues Fenster (_blank)' },
                        { id: '_self', name: 'Gleiches Fenster (_self)' }
                    ]} validate={validateLinkTarget}/>
            </Grid>
        </Grid>
    </SimpleForm>
)

export const ECBEdit = props => (
    <Edit {...props} redirect="list">
        <ECBForm {...props} title="Embedded Customer Branding bearbeiten" />
    </Edit>
);

export const ECBCreate = props => (
    <Create {...props} redirect="list">
        <ECBForm {...props} title="Neues Embedded Customer Branding anlegen" />
    </Create>
);
